// EventsPage: not built yet, so it says so instead of showing sample content.
import React from "react";
import { ComingSoon } from "../components/ui";

const EventsPage = () => <ComingSoon title="Events" description="Plan and track hotel events." />;

export default EventsPage;
